import { Link } from "react-router-dom";
import Header from "../../components/Header";
import * as S from "./styled";
import googlePlay from "../../assets/Img/google_play.png";
import apphomeEN from "../../assets/Img/apphomeEN.png";
import apphomePT from "../../assets/Img/apphomePT.png";
import { useTranslation } from 'react-i18next';
import Footer from "../../components/Footer";
import ButtonDefault from "../../components/ButtonDefault";

export default function Checkout() {
    const { t } = useTranslation();
    const languageTag = navigator.language.split('-')[0];

    return (
        <S.Container>
            <Header />
            <S.SubContainer>
                <S.Title>
                    {t('download_app_title')}
                </S.Title>
                <S.Description>
                    {t('download_app_description')}
                </S.Description>

                <S.Content>
                    <S.Image src={languageTag ? apphomePT : apphomeEN} alt="" />
                </S.Content>

                <S.SubContent>

                    <a href="https://pay.hotmart.com/X95026483O" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'flex', justifyContent: 'center' }}>
                        <ButtonDefault
                            title={t('button_text')}
                        />
                    </a>

                </S.SubContent>

            </S.SubContainer>
            <Footer />

        </S.Container>
    );
}
